var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "59.000000pt",
    height: "53.000000pt",
    viewBox: "0 0 59.000000 53.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,53.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191 471 c-29 -10 -65 -27 -80 -38 -58 -44 -89 -141 -70 -218 11 -42 70 -125 90 -125 5 0 9 47 9 104 0 90 3 107 23 136 39 60 78 74 202 78 l110 4 28 39 28 39 -143 0 c-112 -1 -154 -5 -197 -19z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 306 c-10 -7 -19 -24 -20 -37 -3 -23 -1 -24 87 -29 l90 -5 3 -47 3 -48 -95 0 -96 0 0 -45 0 -45 105 0 c175 0 198 21 193 176 l-3 89 -125 2 c-92 2 -130 -1 -142 -11z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a47626935d7d5965ce8228300b23a17c.svg";
export { ForwardRef as ReactComponent };